export default function HoverArrow({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <defs>
        <clipPath id="hoverArrow-path-a">
          <path transform="translate(70 916)" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
      <g transform="rotate(-90 -415 501)" clipPath="url(#hoverArrow-path-a)" fill="none">
        <g>
          <g>
            <path d="M78 918.5v11" />
            <path d="m73.5 925 4.5 4.5 4.5-4.5" />
          </g>
        </g>
        <g>
          <path d="M78 902.5v11" />
          <path d="m73.5 909 4.5 4.5 4.5-4.5" />
        </g>
      </g>
    </svg>
  );
}
